import React from 'react';
export function FooterSection() {
  return <footer className="bg-footer py-8 px-4 border-t border-white/5" data-id="element-57">
      <div className="max-w-4xl mx-auto text-center" data-id="element-58">
        <h3 className="text-accent-gold font-bold text-lg mb-2" data-id="element-59">
          CONTROLA LA ANSIEDAD Y LOS ATAQUES DE PÁNICO
        </h3>
        <p className="text-text-secondary text-sm mb-5" data-id="element-60">
          Pack Digital · Edición 2026 · Envío por email en PDF
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-white text-sm mb-5" data-id="element-61">
          <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-62">
            Política de Privacidad
          </a>
          <span className="text-white/20" data-id="element-63">|</span>
          <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-64">
            Términos y Condiciones
          </a>
          <span className="text-white/20" data-id="element-65">|</span>
          <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-66">
            Contacto
          </a>
          <span className="text-white/20" data-id="element-67">|</span>
          <a href="#" className="hover:text-accent-teal transition-colors" data-id="element-68">
            Garantía y Devoluciones
          </a>
        </div>

        <p className="text-text-secondary/60 text-xs max-w-[600px] mx-auto mb-4 leading-relaxed" data-id="element-69">
          Este material es de carácter psicoeducativo e informativo. No
          reemplaza el diagnóstico, tratamiento ni la atención de un profesional
          de la salud mental. Ante síntomas severos, consultá un profesional.
        </p>

        <p className="text-text-secondary/40 text-xs" data-id="element-70">
          © 2026 · Controla la Ansiedad · Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}